import cn from 'classnames';

export const MainContainer = ({ showModal, children }) => (
  <div id='NavContainer' className={cn('fixed inset-x-0 top-0 z-nav-bar flex flex-col', { 'sm:bottom-0': showModal })}>
    {children}
  </div>
);
